<template>
  <!-- <div style="padding: 2vw">
    <div class="m-card" style="background: #32c04055">
      <div style="display: flex; justify-content: center">
        <img src="" alt="logo" />
      </div>
      <div style="display: flex">
        <div>
            <div></div>
            <div></div>
            </div>
        <div><img src="" alt="building" /></div>
      </div>
    </div>
  </div> -->
  <div
    class="container-tv"
    :style="{ 'background-image': 'url(' + img_bg + ')' }"
    style="background-size: cover"
  >
    <div class="card_info">
      <div class="m-card" style="background: #6db792de; color: #000">
        <div style="display: flex; justify-content: center; position: relative">
          <!-- <div>
            <img
              src="@/assets/images/coe/logo.gif"
              alt="logo"
              style="height: 100px"
            />
          </div>
          <div>
            <img
              src="@/assets/images/coe/name.png"
              alt="logo"
              style="height: 100px"
            />
          </div> -->
          <div>
            <img
              src="@/assets/images/coe/logo.png"
              alt="logo"
              style="height: 100px"
            />
          </div>
        </div>
        <div style="display: flex; padding-left: 5%">
          <div
            style="
              width: 40%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
            "
          >
            <div style="font-size: 200%">
              {{ day }}
            </div>
            <div style="font-size: 500%">{{ time }}</div>
            <div
              style="
                font-size: 300%;
                display: flex;
                gap: 5px;
                font-weight: 600;
                align-items: center;
              "
            >
              <span class="material-icons-outlined" style="color: red">
                device_thermostat
              </span>
              <div>{{ temp }}°C</div>
            </div>
            <div
              style="
                font-size: 300%;
                display: flex;
                gap: 5px;
                font-weight: 600;
                align-items: center;
              "
            >
              <span class="material-icons" style="color: blue"> cloud </span>
              <div>{{ hum }}%</div>
            </div>
          </div>
          <div style="width: 60%; position: relative">
            <img
              src="@/assets/images/coe/building.png"
              alt="building"
              style="width: 100%"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="text_real">
      <div
        class="m-card"
        style="
          align-items: center;
          font-size: 150%;
          font-weight: bold;
          background: #ffffffcf;
        "
      >
        <div>Real time Air Pullution</div>
      </div>
    </div>
    <div class="PM" style="height:100%">
      <div
        class="m-card p-0"
        style="
          background: #ffffffcf;
          color: #000;
          border-radius: 50px 20px 20px 20px;
          height:100%;
        "
      >
        <div
          style="
            
            display: flex;
            align-items: center;
            border-radius: 50px 20px 20px 50px;
          "
          :style="{background: levelpm}"
        >
          <div style="background: #8fffc7; border-radius: 50%; width: 10%">
            <img
              src="@/assets/images/kubota/h gif/200-2.gif"
              alt=""
              style="width: 100%"
            />
          </div>
          <div
            style="
              font-size: 300%;
              font-weight: bold;
              width: 100%;
              text-align: center;
            "
          >
            PM 2.5
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 3%;
            height:100%;
            justify-content: space-around;
          "
        >
          <div style="font-size: 600%; font-weight: cold">
            {{ pm }} µg./m<sup>3</sup>
          </div>
          <div style="font-size: 170%">ฝุ่นละอองขนาดเล็กไม่เกิน 2.5 ไมครอน</div>
        </div>
      </div>
    </div>
    <div class="grade">
      <div class="m-card" style="background: #ffffffcf">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-content: center;
          "
          id="lv_Air_Quality"
          class="centerHeader"
        >
          <div
            style="display: flex"
            class="al-center"
            v-for="i in labeltext2"
            :key="i"
          >
            <div>
              <vs-icon
                size="25px"
                class="mr-1"
                :color="i.color"
                icon="fiber_manual_record"
              ></vs-icon>
            </div>
            <div>
              <a class="text_size" style="font-weight: 800">{{ i.text }}</a
              ><br /><a class="thFontthai text_size">{{ i.th }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grade_air">
      <div
        align="center"
        class="div-detail-aqi"
        style="
          border: 1px solid #525c55;
          border-radius: 10px;
          background: #ffffffcf;
        "
      >
        <div
          style="
            border: 1px solid #525c55;
            border-radius: 10px;
            background: #76d250;
            height: 100%;
            width: 10%;
            margin-right: 1em;
          "
        >
          <h5 class="text_size">
            <b>Air Quality index level of health concern</b>
          </h5>
        </div>
        <div
          style="display: flex"
          class="al-center mr-1"
          v-for="i in labeltextaqi"
          :key="i"
        >
          <div class="mr-1">
            <img style="width: 50px" :src="i.img" />
          </div>
          <div :style="{ color: i.color }">
            <a class="text_size" style="font-weight: 800">{{ i.text }}</a>
            <br /><a class="text_size">{{ i.lv }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="card_chart">
      <div class="m-card p-0" style="background: #6db792de; color: #000;height:100%">
        <div
          style="
            background: #42cf9b;
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            style="
              font-size: 300%;
              font-weight: bold;
              color: #525c55;
              background: #8fffc7;
              border-radius: 10px;
              padding: 2%;
              width: max-content;
            "
          >
            Temperature, Humidity & PM2.5
          </div>
          <div class="mr-4">
            <vs-select v-model="select1" width="120px" @change="selectData">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in options1"
              />
            </vs-select>
          </div>
        </div>
        <div style="padding: 1%">
          <line-chart
            :chartdata="chartData"
            :options="optionsChart"
            :areaColors="['#007bff', '#f707ff', '#ffa807']"
            :height="heightChartC"
            :heightChart="heightChartColorC"
          ></line-chart>
        </div>
      </div>
    </div>
    <div class="air">
      <div
        class="m-card"
        style=" color: #000; align-items: center"
        :style="{background: levelcardaqi}"
      >
        <div style="font-size: 300%; font-weight: bold; color: #525c55">
          AIR QUALITY
        </div>
        <div
          style=" font-weight: bold;text-align: center;"
          :style="{ color: levelaqi ,'font-size':leveltextsizeaqi}"
        >
          {{leveltextaqi}}
        </div>
      </div>
    </div>
    <div class="aqi">
      <div
        class="m-card"
        style="
          color: #000;
          align-items: center;
          flex-direction: row;
        "
        :style="{background: levelcardaqi}"
      >
        <!-- <div style="height:200px;">
          <img src="@/assets/images/yamahaaqi/lv/lv1.png" alt="" style="height:100%">
        </div> -->
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
          "
        >
          <div
            style="font-size: 700%; font-weight: bold"
            :style="{ color: levelaqi }"
          >
            {{aqi}}
          </div>
          <div style="font-size: 300%; font-weight: bold; color: #525c55">
            AQI
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: { LineChart },
  data() {
    return {
      img_bg: require("@/assets/images/coe/bg.jpeg"),
      chartData: {
        datasets: [
          {
            data: [25, 26, 26, 25, 26, 26, 27],
            label: "Temperature ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#007bff",
            //     backgroundColor:  this.gradient,
          },
          {
            data: [49, 50, 50, 49, 51, 50, 51],
            label: "Humidity ( % )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#f707ff",
            //     backgroundColor:  this.gradient,
          },
          {
            data: [20, 25, 20, 21, 24, 23, 24],
            label: "PM 2.5 ( µg./m3 )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#ffa807",
            //     backgroundColor:  this.gradient,
          },
        ],
        labels: [6.0, 7.0, 8.0, 9.0, 10.0],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
          // xAxes: [
          //   {
          //     // ticks: {
          //     //   // beginAtZero: true,
          //     //   fontColor: "#ffffff",
          //     // },
          //     // scaleLabel: {
          //     //   // display: true,
          //     //   // labelString: "Timestamp",
          //     // },
          //     type: 'time',
          //   },
          // ],
        },
      },
      labeltextaqi: [
        {
          img: require("@/assets/images/yamahaaqi/lv/lv1.png"),
          text: "Good",
          th: "ดี",
          color: "#168848",
          lv: "0 to 50",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv2.png"),
          text: "Moderate",
          th: "ปานกลาง",
          color: "#c4b50c",
          lv: "51 to 100",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv3.png"),
          text: "Unhealthy",
          th: "เริ่มมีผลต่อสุขภาพ",
          color: "#bf7c2f",
          lv: "101 to 150",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv4.png"),
          text: "Literally Unhealthy",
          th: "มีผลต่อสุขภาพมาก",
          color: "#c41c0c",
          lv: "151 to 200",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv5.png"),
          text: "Very Unhealthy",
          th: "มีผลต่อสุขภาพมาก",
          color: "#9a2fbf",
          lv: "201 to 300",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv6.png"),
          text: "Hazardous",
          th: "อันตรายต่อสุขภาพ",
          color: "#745726",
          lv: "301 to 500",
        },
      ],
      labeltext2: [
        { text: "Excellent", th: "ดีมาก", color: "#3BCCFF" },
        { text: "Good", th: "ดี", color: "#00D257" },
        { text: "Moderate", th: "ปานกลาง", color: "#FFDF2F" },
        { text: "Unhealthy", th: "เริ่มมีผลต่อสุขภาพ", color: "#F6942B" },
        { text: "Very Unhealthy", th: "มีผลต่อสุขภาพมาก", color: "#FF3235" },
      ],
      timeout: null,
      intervalTime: null,
      day: null,
      time: null,
      temp: null,
      hum: null,
      pm: null,
      aqi: null,
      options1: [
        { value: "daily", label: "Day" },
        { value: "monthly", label: "Month" },
        { value: "yearly", label: "Year" },
      ],
      select1: "daily",
      raw_data: null,
    };
  },
  computed: {
    heightChartC(){
      console.log(window)
      if (window.innerHeight > window.innerWidth) {
        return 200
      }
      return 400
    },
    heightChartColorC(){
      if (window.innerHeight > window.innerWidth) {
        return 150
      }
      return 350
    },
    levelpm(){
      if (this.pm >= 0 && this.pm <= 25) {
        return '#3BCCFF'
      }else if (this.pm >= 26 && this.pm <= 37) {
        return '#00D257'
      }else if (this.pm >= 38 && this.pm <= 50) {
        return '#FFDF2F'
      }else if (this.pm >= 51 && this.pm <= 90) {
        return '#F6942B'
      }else if (this.pm >= 91 ) {
        return '#FF3235'
      }
    },
    levelaqi(){
      if (this.aqi >= 0 && this.aqi <= 50) {
        return '#168848'
      }else if (this.aqi >= 51 && this.aqi <= 100) {
        return '#c4b50c'
      }else if (this.aqi >= 101 && this.aqi <= 150) {
        return '#bf7c2f'
      }else if (this.aqi >= 151 && this.aqi <= 200) {
        return '#c41c0c'
      }else if (this.aqi >= 201 && this.aqi <= 300) {
        return '#9a2fbf'
      }else if (this.aqi >= 301 && this.aqi <= 500) {
        return '#745726'
      }
    },
    levelcardaqi(){
      if (this.aqi >= 0 && this.aqi <= 50) {
        return '#76D250de'
      }else if (this.aqi >= 51 && this.aqi <= 100) {
        return '#FFDF2Fde'
      }else if (this.aqi >= 101 && this.aqi <= 150) {
        return '#ffbd76de'
      }else if (this.aqi >= 151 && this.aqi <= 200) {
        return '#ff8686de'
      }else if (this.aqi >= 201 && this.aqi <= 300) {
        return '#B04690de'
      }else if (this.aqi >= 301 && this.aqi <= 500) {
        return '#d78e2fde'
      }
    },
    leveltextaqi(){
      if (this.aqi >= 0 && this.aqi <= 50) {
        return 'Good'
      }else if (this.aqi >= 51 && this.aqi <= 100) {
        return 'Moderate'
      }else if (this.aqi >= 101 && this.aqi <= 150) {
        return 'Unhealthy'
      }else if (this.aqi >= 151 && this.aqi <= 200) {
        return 'Literally Unhealthy'
      }else if (this.aqi >= 201 && this.aqi <= 300) {
        return 'Very Unhealthy'
      }else if (this.aqi >= 301 && this.aqi <= 500) {
        return 'Hazardous'
      }
    },
    leveltextsizeaqi(){
      if (this.aqi >= 0 && this.aqi <= 50) {
        return '700%'
      }else if (this.aqi >= 51 && this.aqi <= 100) {
        return '700%'
      }else if (this.aqi >= 101 && this.aqi <= 150) {
        return '700%'
      }else if (this.aqi >= 151 && this.aqi <= 200) {
        return '400%'
      }else if (this.aqi >= 201 && this.aqi <= 300) {
        return '460%'
      }else if (this.aqi >= 301 && this.aqi <= 500) {
        return '650%'
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    clearInterval(this.intervalTime);
  },
  mounted() {
    let label = [];
    for (let i = 7; i > 0; i--) {
      label.push(this.$moment().subtract(i, "h").format("HH:00"));
    }
    this.chartData.labels = label;

    this.getdata();

    this.intervalTime = setInterval(() => {
      let time = this.$moment().format("YYYY-MM-DD HH:mm");
      this.day = time.split(" ")[0];
      this.time = time.split(" ")[1];
    }, 1000);
  },
  methods: {
    selectData() {
      let data = this.raw_data.humidity[this.select1]
      console.log(data);
      this.chartData.labels = this.raw_data.temp[this.select1].timestamp
      this.chartData.datasets[0].data = this.raw_data.temp[this.select1].data
      this.chartData.datasets[1].data = this.raw_data.humidity[this.select1].data
      this.chartData.datasets[2].data = this.raw_data.pm25[this.select1].data

      // let label = []
      // for (let i = 0; i < data.timestamp.length; i++) {
        
      // }
    },
    async getdata() {
      try {
        let res = await this.$API.get("worth/getdashboard");
        console.log(res.data);
        this.raw_data = res.data;
        this.temp = res.data.current.data.temperature;
        this.hum = res.data.current.data.humidity;
        this.pm = res.data.current.data.pm2_5;
        this.aqi = res.data.current.data.aqi;


        this.selectData()
      } catch (error) {
        console.error(error);
      }
      this.timeout = setTimeout(() => {
        this.getdata();
      }, 1000 * 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.card_info {
  grid-area: card_info;
  // background: #0ff;
}

.a {
  color: #6db77d;
}

.text_real {
  grid-area: text_real;
  // background: #0ff;
}

.PM {
  grid-area: PM;
  // background: #0ff;
}

.grade {
  grid-area: grade;
  // background: #0ff;
}

.grade_air {
  grid-area: grade_air;
  // background: #0ff;
}

.card_chart {
  grid-area: card_chart;
  // background: #0ff;
}

.air {
  grid-area: air;
  // background: #0ff;
}

.aqi {
  grid-area: aqi;
  // background: #0ff;
}

.div-detail-aqi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}

@media (orientation: landscape) {
  .container-tv {
    height: 100vh;
    padding: 2vw 1vw 1vw 1vw;
    display: grid;
    align-items: center;
    grid-template-columns: 30vw 30vw auto;
    grid-template-rows: 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% auto auto;
    gap: 0.5vw 0.5vw;
    grid-auto-flow: row;
    grid-template-areas:
      "aqi air card_info"
      "aqi air card_info"
      "card_chart card_chart card_info"
      "card_chart card_chart text_real"
      "card_chart card_chart PM"
      "card_chart card_chart PM"
      "card_chart card_chart PM"
      "grade_air grade_air grade";
  }
}
@media (orientation: portrait) {
  .container-tv {
    height: 100vh;
    padding: 2vw;
    display: grid;
    grid-template-columns: 50% auto;
    grid-template-rows: auto auto auto auto auto auto 5vh;
    gap: 1vw 1vw;
    grid-auto-flow: row;
    grid-template-areas:
      "card_info card_info"
      "text_real text_real"
      "PM PM"
      "grade grade "
      "aqi air"
      "card_chart card_chart "
      "grade_air grade_air ";
  }
}
</style>